/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Configuration update request
 * @export
 * @interface UpdateIntegrationInstanceConfigurationRequest
 */
export interface UpdateIntegrationInstanceConfigurationRequest {
    /**
     * New configuration data (JSON string)
     * @type {string}
     * @memberof UpdateIntegrationInstanceConfigurationRequest
     */
    _configuration: string;
}

/**
 * Check if a given object implements the UpdateIntegrationInstanceConfigurationRequest interface.
 */
export function instanceOfUpdateIntegrationInstanceConfigurationRequest(value: object): value is UpdateIntegrationInstanceConfigurationRequest {
    if (!('_configuration' in value) || value['_configuration'] === undefined) return false;
    return true;
}

export function UpdateIntegrationInstanceConfigurationRequestFromJSON(json: any): UpdateIntegrationInstanceConfigurationRequest {
    return UpdateIntegrationInstanceConfigurationRequestFromJSONTyped(json, false);
}

export function UpdateIntegrationInstanceConfigurationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateIntegrationInstanceConfigurationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        '_configuration': json['configuration'],
    };
}

export function UpdateIntegrationInstanceConfigurationRequestToJSON(json: any): UpdateIntegrationInstanceConfigurationRequest {
    return UpdateIntegrationInstanceConfigurationRequestToJSONTyped(json, false);
}

export function UpdateIntegrationInstanceConfigurationRequestToJSONTyped(value?: UpdateIntegrationInstanceConfigurationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'configuration': value['_configuration'],
    };
}

